var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFrame591(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 23,
    height: 24,
    viewBox: "0 0 23 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.8247 0H0V8.286H10.8247C12.8903 8.286 14.5662 9.95608 14.5662 12C14.5662 14.0436 12.8903 15.714 10.8247 15.714H0V24H10.8247C17.4792 24 22.898 18.6211 22.898 12C22.898 5.37893 17.4792 0 10.8247 0Z",
    fill: "#EB5757"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFrame591);
export default __webpack_public_path__ + "static/media/Frame 59 (1).ab337af14d6d0cd6a094a1eb1549f5f1.svg";
export { ForwardRef as ReactComponent };